import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc, collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const AuthContext = createContext(null);
const normalizeRole = (rawRole) => String(rawRole || '').trim().toLowerCase();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          // Recupera profilo utente: prima per UID, fallback per email (anagrafiche legacy).
          let profile = null;
          const docRef = doc(db, 'utenti', currentUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            profile = docSnap.data();
          } else if (currentUser.email) {
            const qByEmail = query(
              collection(db, 'utenti'),
              where('email', '==', currentUser.email.toLowerCase()),
              limit(1)
            );
            const byEmailSnap = await getDocs(qByEmail);
            if (!byEmailSnap.empty) {
              profile = byEmailSnap.docs[0].data();
            } else {
              // Fallback ulteriore per eventuali record salvati senza lower-case.
              const qByEmailRaw = query(
                collection(db, 'utenti'),
                where('email', '==', currentUser.email),
                limit(1)
              );
              const byEmailRawSnap = await getDocs(qByEmailRaw);
              if (!byEmailRawSnap.empty) {
                profile = byEmailRawSnap.docs[0].data();
              }
            }
          }
          const normalizedRole = normalizeRole(profile?.ruolo) || 'cassiere';
          setUserProfile(profile ? { ...profile, ruolo: normalizedRole } : null);
          setRole(normalizedRole);
        } catch (error) {
          console.error("Errore recupero ruolo utente:", error);
          setUserProfile(null);
          setRole(null);
        }
      } else {
        setUser(null);
        setRole(null);
        setUserProfile(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = () => signOut(getAuth());

  return <AuthContext.Provider value={{ user, role, userProfile, loading, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);